<template>
  <user-list-table />
</template>

<script>
import UserListTable from "../../components/user/UserListTable";

export default {
  name: "UserList",
  components: {
    'user-list-table': UserListTable
  },
}
</script>

<style scoped>

</style>